import React, { useState } from "react";
import { RunnerUpHeader } from "../../../ui";
import SelectField from "../../../library/components/Select/index";
import "./countingsupervisoreciofficer.css";
import "./eciReports.css"
import { Validators } from "../../../library/utilities/Validator";
import { useGetCountingSupervisorEciReportMutation, useGetStatesStatusForceWiseQuery } from "../../../services/reportsServices";
import pdfIcon from "../../../images/pdfIcon.png"
import excelIcon from "../../../images/excelIcon.png"
import { downloadExcelFile, downloadPdfFile } from "../../utilities/utils"
import Table from "../../../ui/datatable/DataTable";
import LeftMenu from "../../AnalyticsModule/Left";
import MultiSelectCheckBox from "../../../ui/multiSelectCheckbox/MultiSelectCheckBox"
import RunnerUpHeaderNew from "../../../ui/runnerUpHeader/RunnerUpHeaderNew";


const CountingSupervisorEciReport = () => {
  const [totalNoOfRecords, setTotalNoOfRecords] = useState()
  const [tableData, setTableData] = useState([]);
  const reportName = "Counting Supervisor Report"
  const SheetName = "Counting Supervisor Report"
  const [selected,setSelected] =useState([])
  const { data: getElectionAnnouncedState } = useGetStatesStatusForceWiseQuery();
  const [Error, setError] = useState({});
  const stateList = [];
  const tableHeader = [];
  const columns = [
    {
      Header: "State Name",
      accessor: "col1",
    },
    {
      Header: "District No. and Name",
      accessor: "col2",
    },
    {
      Header: "AC/PC No. and Name",
      accessor: "col3",
    },
    {
      Header: "Counting Supervisor Id and Name",
      accessor: "col4",
    },
    {
      Header: "Mobile Number",
      accessor: "col5",
    },
    {
      Header: "Email Id",
      accessor: "col6",
    },
    {
      Header: "Login Status",
      accessor: "col7",
    },
    {
      Header: "Scanning Status",
      accessor: "col8",
    },

  ];
  columns.map((item) => {
    tableHeader.push(item.Header)
  })

  const constType = [
    { value: "", label: "Select constituency" },
    { value: "AC", label: "AC" },
    { value: "PC", label: "PC" },
  ];
  const [states, setStates] = useState({
    stateValue: "",
    constTypeValue: '',
  });
  const getError = (key, value) => {
    let error = { ...Error };
    if (value && value.message) {
      setError({ ...Error, [key]: value.message });
    } else {
      delete error[key];
      setError(error);
    }
  };
  getElectionAnnouncedState?.payload?.map((item) => {
    stateList?.push({
      value: item.stateCd,
      label: item.stateName,
    });
  });
  const [saveData] = useGetCountingSupervisorEciReportMutation()

  const handleChange = (key, value) => {
    setStates((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };
  const getErrorValue = (key, value) => {
    let error = { ...Error }
    if (value && value.message) {
      setError({ ...Error, [key]: value.message })
    } else {
      delete error[key]
      setError(error)
    }
  }

  const renderTableData = () => {
    let error = {};
    if (selected === "" || selected.length === 0) {
      error["stateValue"] = "This Field is required"
      
    }
    if (!states.constTypeValue || states.constTypeValue === "" || states.constTypeValue.length == 0) {
      error["constTypeValue"] = "This Field is required"
    
    }
    if (Object.keys(error).length) {
      setError(error);
      return;
    }   
      let statesCodesArray = []
      selected?.map((item) => {
        statesCodesArray.push(item.value)
      })

      let payload = {
        "stateCd": statesCodesArray,
        "constType": states.constTypeValue
      }
     
      saveData(payload)
        .unwrap()
        .then((res) => {
          let tData = []
          res?.payload?.map((item) => {
            tData.push({
              "col1": item.stateName,
              "col2": `${item.districtCd}-${item.districtName}`,
              "col3": `${item.acPcNo}-${item.acPcName}`,
              "col4": `${item.csid}-${item.csname}`,
              "col5": item.mobileNumber,
              "col6": item.emailId,
              "col7": item.loginStatus==="Y"?"Yes":"No",
              "col8": item.scanningStatus==="Y"?"Started":"Not Started",
            });
            
          });
          setTableData(tData)
          setTotalNoOfRecords(res?.payload?.length)
         
        }).catch((error) => {
          if (error?.data?.message === "No record found") {

            setTableData([])
          }
         
        })

  };
  return (
    <>
      <LeftMenu>
        <div className="container box shadow ">
          <div className="row">
            <div className="col-md-12">
              <RunnerUpHeaderNew title={reportName} 
              onPdfClick={() => downloadPdfFile(reportName, tableHeader, tableData)} 
              onExcelClick={() => downloadExcelFile(reportName, SheetName, tableHeader, tableData)} 
               />
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
            <MultiSelectCheckBox
              options={stateList}
              name="stateValue"
              value={selected}
              onChange={setSelected}
              labelledBy="Select"
              validators={[
                {
                  check: Validators.required,
                  message: "This field is required",
                },
              ]}
              getError={(val) => getError("stateValue", val)}
              Error={Error}
            ></MultiSelectCheckBox>
            </div>
            
            <SelectField
              labelClass=""
              inputClass="col-md-2 pr-1"
              name="constTypeValue"
              options={constType}
              value={states.constTypeValue}
              handleChange={(val) => handleChange("constTypeValue", val)}
              validators={[
                {
                  check: Validators.required,
                  message: "This field is required",
                }
              ]}

              getError={(val) => getError("constTypeValue", val)}
              Error={Error}
            />
            <div className="col-md-2 ">
              <button
                type="button"
                className="btn btn-primary btn-sm searchbuttonreport"
                onClick={renderTableData}>
                VIEW
                <span className="pl-2">
                  <i class="fa fa-eye">
                  </i>
                </span>
              </button>
            </div>
          </div>
  
          <div style={{ marginTop: "-40px" }}>
            <Table
              placeholder="Search"
              globalsearch={true}
              emptyMessage="No Record Found"
              selectall={true}
              columns={columns}
              data={tableData?.length === 0 ? [] : tableData}
              size={5}
              tableClassNameCheck="contenttable-eroll"
              pagination
              records
              gotopage
              rows
              numberrows={totalNoOfRecords}
            />
          </div>
        </div>
      </LeftMenu>

    </>
  );
};

export default CountingSupervisorEciReport;
